var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoDarkMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 56,
    viewBox: "0 0 151 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.6292 52.3811H55.2549V25.3325H59.8408V48.2026H72.6292V52.3811Z",
    fill: "#DAE8F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3256 40.7037H93.5081V36.4878H88.2884H81.8009H77.1777V40.7037H81.8009H88.3256Z",
    fill: "#0EC9AC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1777 25.3325V29.5111H81.8009H88.2884H96.1926V25.3325H77.1777Z",
    fill: "#0EC9AC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8009 48.24H77.1777V52.3812H96.1926V48.24H88.3256H81.8009Z",
    fill: "#0EC9AC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M110.585 25.3325H115.208L125.722 52.3811H120.912L118.638 46.6356H107.117L104.88 52.3811H100.033L110.585 25.3325ZM116.997 42.4198L112.859 31.6003L108.758 42.4198H116.997Z",
    fill: "#DAE8F8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M134.26 52.3812H129.674V25.3325H134.26V37.9055L144.364 25.3325H150.068L140.934 36.7862L150.963 52.4185H145.445L137.764 40.6663L134.26 44.9568V52.3812Z",
    fill: "#DAE8F8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9622 16.6023L68.4909 18.2812C67.0368 20.1093 65.1353 21.0047 62.7491 21.0047C60.5494 21.0047 58.7597 20.3331 57.343 18.9527C55.9262 17.5723 55.2178 15.7815 55.2178 13.5803C55.2178 11.3791 55.9262 9.58829 57.3057 8.17057C58.7225 6.79016 60.5121 6.0813 62.6746 6.0813C65.098 6.0813 66.9622 6.9767 68.3044 8.80482L66.7012 10.4464C65.6946 9.02867 64.3896 8.31981 62.7118 8.31981C61.2951 8.31981 60.102 8.80482 59.1326 9.81214C58.2005 10.8195 57.7158 12.0506 57.7158 13.543C57.7158 15.0353 58.2005 16.2665 59.1699 17.2365C60.1393 18.2065 61.3696 18.6916 62.7864 18.6916C64.4642 18.7662 65.8437 18.02 66.9622 16.6023Z",
    fill: "#DAE8F8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9951 6.34253H74.605L78.0724 13.0581L81.5025 6.34253H84.1497L79.3028 15.7443V20.7809H76.8047V15.7443L71.9951 6.34253Z",
    fill: "#DAE8F8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5891 15.8562H91.5319V20.7809H89.1084V6.34253H94.5891C96.3042 6.34253 97.6464 6.75292 98.6158 7.57371C99.5852 8.39449 100.07 9.55106 100.07 11.0434C100.07 12.5357 99.5852 13.6923 98.5785 14.5504C97.6464 15.4085 96.3042 15.8562 94.5891 15.8562ZM94.2909 8.54373H91.5691V13.5804H94.2909C96.5279 13.5804 97.6464 12.7223 97.6464 11.0434C97.6464 9.40182 96.5279 8.54373 94.2909 8.54373Z",
    fill: "#DAE8F8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M116.923 20.7809H114.462V14.5504H107.677V20.7809H105.216V6.34253H107.677V12.3119H114.462V6.34253H116.923V20.7809Z",
    fill: "#DAE8F8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M151.001 20.7809H148.092L145.072 15.8562H142.09V20.7809H139.629V6.34253H145.11C146.825 6.34253 148.167 6.75292 149.136 7.57371C150.106 8.39449 150.59 9.55106 150.59 11.0434C150.59 12.088 150.329 13.0207 149.845 13.7669C149.323 14.5131 148.614 15.0727 147.645 15.4458L151.001 20.7809ZM144.811 8.54373H142.09V13.5804H144.811C147.048 13.5804 148.167 12.7223 148.167 11.0434C148.167 9.40182 147.048 8.54373 144.811 8.54373Z",
    fill: "#DAE8F8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M123.298 12.2747V14.5505H125.759H132.097V12.2747H125.759H123.298Z",
    fill: "#DAE8F8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M125.759 8.54373H133.439V6.34253H123.298V8.54373H125.759Z",
    fill: "#DAE8F8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M123.298 18.5425V20.781H133.439V18.5425H125.759H123.298Z",
    fill: "#DAE8F8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.28247V35.2192L26.8817 8.28247H0Z",
    fill: "#DAE8F8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1788 0V10.0733L36.8365 11.4164L5.03333 43.2405L0 38.2039L38.1788 0Z",
    fill: "#0EC9AC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1784 12.7222V22.7955L36.8362 24.1386L11.3712 49.6202L6.33789 44.5463L38.1784 12.7222Z",
    fill: "#0EC9AC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7139 50.926L13.3477 51.5976L14.0188 52.2318L17.7472 56L38.1788 35.5922V25.4443L12.7139 50.926Z",
    fill: "#0EC9AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDarkMode);
export default __webpack_public_path__ + "static/media/logo-dark-mode.9b09ad05bfe63e5d4ce0dc66a18c1b96.svg";
export { ForwardRef as ReactComponent };